import { render, staticRenderFns } from "./CustomerFindStandardMatch.vue?vue&type=template&id=12b26004"
import script from "./CustomerFindStandardMatch.vue?vue&type=script&lang=ts"
export * from "./CustomerFindStandardMatch.vue?vue&type=script&lang=ts"
import style0 from "./CustomerFindStandardMatch.vue?vue&type=style&index=0&id=12b26004&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports